import { useFetch } from '../utils/hooks'

const DoFetch = ({ fetchDatas, handleFetch }) => {
  const { isLoading, data, error } = useFetch(fetchDatas)
  handleFetch({ isLoading, data, error })
  return null
}

export default DoFetch
